import { createApi } from "@reduxjs/toolkit/query/react";
import customBaseQuery from "../../../utils/customBaseQuery";

export const StatusUpdateEventApi = createApi({
  reducerPath: "statusUpdateEventApi",
  baseQuery: customBaseQuery,
  keepUnusedDataFor: 60,
  endpoints: (builder) => ({
    putStatusUpdateEventApi: builder.mutation({
      query: (payload: {
        eventId: any;
        body: {
          action: string;
          remarks: string;
          sendRemarksToCandidates: boolean;
          sendRemarksToEducators: boolean;
        };
      }) => ({
        url: `/event/status/${payload.eventId}`,
        method: "PUT",
        body: payload.body
      })
    })
  })
});

export const { usePutStatusUpdateEventApiMutation } = StatusUpdateEventApi;
